import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

export default class extends Controller {
  static values = {
    content: String,
    onlyWhenOverflowing: { type: Boolean, default: false },
    allowHtml: { type: Boolean, default: false }
  }

  connect() {
    this.checkAndCreateTooltip()
  }

  disconnect() {
    this.tippyInstance?.destroy()
  }

  contentValueChanged() {
    if (this.tippyInstance) {
      this.tippyInstance.setContent(this.contentValue)
    }
    this.checkAndCreateTooltip()
  }

  checkAndCreateTooltip() {
    if (this.onlyWhenOverflowingValue) {
      const isOverflowing = this.element.scrollWidth > this.element.clientWidth

      if (isOverflowing && !this.tippyInstance) {
        this.createTooltip()
      } else if (!isOverflowing && this.tippyInstance) {
        this.tippyInstance.destroy()
        this.tippyInstance = null
      }
    } else if (!this.tippyInstance) {
      this.createTooltip()
    }
  }

  createTooltip() {
    this.tippyInstance = tippy(this.element, {
      content: this.contentValue,
      allowHTML: this.allowHtmlValue
    })
  }
}
